<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="goAboutHomePage()">
        <ion-icon class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'COMPANY.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
</ion-content>
